home_handler = {

    properties: {
        title: 'Ozarks Transportation Organization Public Comment Map'
    },

    onLoad: function(){
        var self = this;
        // $('#content-root').addClass('swipe');
        home_handler.scrollContent();

        $(document).off("click", ".like-btn");

        map.off("draw:created");
        map.off("draw:drawstart");
        map.off("draw:drawstop");

        self.disableRouteEasyClick();
        mapData.drawnItemsLayer.clearLayers();
        mapData.geoJSONLayer.clearLayers();
        mapData.selectLayer.clearLayers();

        map.closePopup();

        self.disableRouteEasyClick();
        trail_plan_handler.loadData();
        self.enableRouteEasyClick(mapData.geoJSONLayer);

        self.loadSuggestions();
        self.enableRouteEasyClick(mapData.lineStringLayer);

        var markerDrawActive = mapData.drawControl.marker['_enabled'] || undefined;
        var polylineDrawActive = mapData.drawControl.polyline['_enabled'] || undefined;

        if (markerDrawActive){
            $('.marker-input').addClass('animated bounceIn shake').removeClass('hidden');
        }
        else if (polylineDrawActive){
            $('.route-input').addClass('animated bounceIn shake').removeClass('hidden');
        }

        self.updateLS();
        self.loadLikes();
    },

    getRequest: function(){
        var self = this;
        var id = properties.loadHashID;

        if (mapData.features[id]){

            window.location.href = "#/view/" + id;

        }
    },

    scrollTop: function(){
        $('html, body').animate({
           scrollTop: 0},
           800,
           "swing"
        );
    },

    scrollContent: function(){
        $('html, body').animate({
           scrollTop: $('.content-root').offset().top},
           800,
           "swing"
        );
    },

    //Update Local Storage
    updateLS: function(){
        try {
          mapData.pvlk =  JSON.parse( localStorage.getItem( 'pvlk-oto' ) ) || {};
        }
        catch(e) {
          console.log(e);
        }
    },

    //Add to Local Storage
    addLS: function(id){
        var self = this;
        var pg = {};

        pg.ID = id || null;

        if (!mapData.pvlk){
          mapData.pvlk = {}
        }

        if (pg.ID){
          mapData.pvlk[pg.ID] = pg;
        }

        try {
          localStorage.setItem( 'pvlk-oto', JSON.stringify(mapData.pvlk) );
        }
        catch(e) {
          return false;
        }
        self.updateLS();
        return true;
    },

    addLike: function(id, type, popup){

        var self = this;
        var likes = mapData.likes[type][id] || 0;

        $.ajax({
          type: "POST",
          url: mapData.likesURL,
          data: {
            'object': id,
            'type': type
          },
          success: function(json) {
            mapData.likes[type][id] = parseInt(likes) + 1;
            self.addLS(id);

            if (popup){
                if (properties.selectCategories[type]){
                    type = 'suggestions';
                    var data = mapData.geoJSONData[type][id];
                    mapData.features[id]._popup.setContent(self.generatePopUp(data));
                }

                view_handler.getLikes();
            }
            else {
                view_handler.getLikes();
            }

          },
          error: function(xhr, textStatus, errorThrown) {
            console.log(textStatus);
          }
        });
    },

    loadLikes: function(){

        var self = this;

        $.ajax({
            type: "GET",
            url: mapData.likesURL,
            cache: false,
            dataType: "json",
            success: function(json) {
                $.each(json, function(index, value) {
                    if (index != "error" && mapData.likes[value.type][value.object] == undefined) {
                        mapData.likes[value.type][value.object] = value.votes;
                    }
                });
                if ($.isEmptyObject(mapData.likes)) {
                    console.log("No Votes");
                }

            },
            error: function(xhr, textStatus, errorThrown) {
            }
        });
    },


    fixedComment: function(comment, category) {
        comment = comment.replace(/(<([^>]+)>)/gi, "");

        if ($.trim(comment).length == 0) {
            comment = properties.selectCategories[category].title;
        }
        return '<br><div class="comment"><p>"' + comment + '"</p></div>';
    },

    fixedMiles: function(miles){
        miles = miles.toFixed(2);

        return miles + ' miles';
    },

    fixedLikes: function(likes) {
        if (likes == 1) {
            return "1 person likes this.";
        } else if (likes > 1) {
            return likes + " people like this.";
        }
        else  if (likes == 0){
          return "No one has liked this."
        }
    },

    likeBtn: function(marker, type) {
        if (marker in mapData.pvlk){
          return '';
        }
        else {
          return '<button class="inline-block like-btn" type="'+type+'"marker="'+marker+'" >Like this</button> '
        }
    },

    commentBtn: function(marker, type) {
        return '<a class="inline-block btn-novel" href="#/view/' + type + '/'+marker+'" >Comment</a>';
    },

    onMarkerClick: function(marker){
        var self = this;
        var location = marker.getLatLng();

        var circle = new L.CircleMarker(location, {
            radius: 25,
            fillColor: "#ffe612",
            color: "#000",
            weight: 1,
            opacity: 0,
            fillOpacity: 0.8,
            clickable: false
          });

          mapData.selectLayer.addLayer(circle);
          self.resetSelectLayers();

          window.location.href = "#/view/suggestions/" + marker.options.id;
    },

    onPolylineClick: function(clickArea, points){

        var self = this;
        var highlights = L.featureGroup();

        function highlightSelected(){
            var pointList = points.getLatLngs();
            var polyline = new L.Polyline(pointList, {
                stroke: true,
                color: "#ffe612",
                weight: 10,
                opacity: 1,
                smoothFactor: 1,
                clickable: false
            });
            highlights.addLayer(polyline);
        };

        var type = points.options.type;

        if (type && type != 'suggestions'){
            var data = mapData.geoJSON[type].getLayers();
            $.each(data, function(index, value) {
                if (value.feature.properties.id == points.options.id){
                    var layers = value.getLayers();

                        $.each(layers, function(index, value) {
                            points = value;
                            highlightSelected();
                        });

                }
            });
        }
        else {
            highlightSelected();
        }


        mapData.selectLayer.addLayer(highlights);
        mapData.selectLayer.bringToBack();
        self.resetSelectLayers();

        window.location.href = "#/view/" + type + "/" + points.options.id;
    },

    onPolygonClick: function(polygon){

        var self = this;

        var highlights = L.featureGroup();
        // var selectedPolygon = $(polyon).clone();

        var selectedPolygon = new L.Polyline(polygon.getLatLngs(), {
            color: '#000',
            weight: 15,
            fillColor: "#000",
            opacity: 0.5,
            fillOpacity: 0
        });

        highlights.addLayer(selectedPolygon);

        mapData.selectLayer.addLayer(highlights);
        mapData.selectLayer.bringToBack();
        self.resetSelectLayers();
    },

    resetBaseLayers: function(){
        try {
            map.removeLayer(mapData.baseLayerI);
            map.removeLayer(mapData.baseLayerBike);
            map.removeLayer(mapData.baseLayerPed);
        }
        catch(err) {
            console.log(err);
        }
    },


    resetSelectLayers: function(){
        var selectLayer = mapData.selectLayer.getLayers();
        $.each( selectLayer, function( key, value ) {
            if (key < (selectLayer.length - 1)){
                mapData.selectLayer.removeLayer(value);
            }
        });
    },

    enableRouteEasyClick: function(targetLayer){

        var self = this;

        map.on("click", function(e) {

            //Check to see if draw is enabled.
            var markerDrawActive = mapData.drawControl.marker['_enabled'] || undefined;
            var polylineDrawActive = mapData.drawControl.polyline['_enabled'] || undefined;

            var clickedArea = e.latlng;
            var closestLayer = L.GeometryUtil.closestLayer(map, targetLayer.getLayers(), e.latlng);

            //If a close layer exists and draw is disabled, execute.
            if (closestLayer && markerDrawActive != true && polylineDrawActive != true) {
                if (closestLayer.distance <= 20){
                    var closest = L.GeometryUtil.closest(map, closestLayer.layer, e.latlng, false);
                    var latlng = L.latLng(closest.lat, closest.lng);
                    console.log(latlng);
                    self.onPolylineClick(latlng, closestLayer.layer);

                    window.location.href = "#/view/" + closestLayer.layer.options.type + "/" + closestLayer.layer.options.id;
                }
            }
        });

    },


    disableRouteEasyClick: function(){
        map.off("click");
    },

    generatePopUp: function(value){
        var self = this;

        console.log(value);

        var likesNum = mapData.likes[value.category][value.id] || 0;
        return '<b>By: </b><span class="name">' + value.name + "</span>" + self.fixedComment(value.comment, value.category) + '<div class="likes animated fadeInDown">' + self.fixedLikes(likesNum) + '</div>' + self.likeBtn(value.id, value.category) + self.commentBtn(value.id, 'suggestions');
    },

    setData: function(){

        var self = this;

        mapData.lineStringLayer.clearLayers();
        mapData.pointsLayer.clearLayers();

        $.each(mapData.geoJSONData.suggestions, function(index, value) {

            //Point Items
            if (mapData.features[value.id] == undefined && value.type == 'Point') {
                var geometry = JSON.parse(value.geometry);

                mapData.features[value.id] = L.marker([ geometry[1], geometry[0] ], {
                    icon: new L.DivIcon({iconUrl: "img/legend/" + value.category + ".png"}),
                    id: value.id
                }).on('click', function(e) {
                    self.onMarkerClick(e.target);
                });

                // mapData.features[value.id].bindPopup(self.generatePopUp(value));
            }

            //Polyline Items
            else if (mapData.features[value.id] == undefined && value.type == 'LineString') {
                var geometry = JSON.parse(value.geometry);
                var pointList = [];

                $.each(geometry, function(index, value) {
                    var point = new L.LatLng(value[1], value[0]);
                    pointList.push(point);
                });

                mapData.features[value.id] = new L.Polyline(pointList, {
                    stroke: true,
                    color: properties.selectCategories[value.category].color,
                    color: '#ff6c00',
                    weight: 4,
                    opacity: 1,
                    dashArray: "5,10",
                    smoothFactor: 1,
                    className: 'linePoints',
                    id: value.id,
                    type: 'suggestions'
                }).on('click', function(e) {
                    self.onPolylineClick(e.latlng, e.target);
                });

                // mapData.features[value.id].bindPopup(self.generatePopUp(value));
            }
        });

        $.each(mapData.features, function(index, value) {
            if (this instanceof L.Marker) {
                mapData.pointsLayer.addLayer(this);
            } else if (this instanceof L.Path) {
                mapData.lineStringLayer.addLayer(this);
            }
        });


    },

    loadSuggestions: function(){

        var self = this;

        $.ajax({
            type: "GET",
            url: mapData.suggestionsURL,
            cache: false,
            dataType: "json",
            success: function(json) {

                $.each(json, function(index, value) {
                    if (index != "error" && mapData.geoJSONData.suggestions[value.id] == undefined) {
                        mapData.geoJSONData.suggestions[value.id] = value;
                    }
                });
                if ($.isEmptyObject(mapData.geoJSONData.suggestions)) {
                    console.log("No Suggestions");
                } else {
                    self.setData();
                }

            },
            error: function(xhr, textStatus, errorThrown) {
            }
        });
    },


    events: function() {
        var self = this;
        self.onLoad();

        $(document).on("click", ".like-btn", function(event){
            var id = $(this).attr('marker');
            var type = $(this).attr('type');
            self.addLike(id, type, true);
        });

        $('.add-route').click(function(event) {
            suggest_key_handler.disableDraw();
            mapData.selectLayer.clearLayers();
            mapData.drawControl.polyline.enable();
            suggest_key_handler.hideEdits();
            $('.route-input').addClass('animated bounceIn shake').removeClass('hidden');
            suggest_key_handler.hideContent();
            return false;
        });

         $('.add-point').click(function(event) {
            suggest_key_handler.disableDraw();
            mapData.selectLayer.clearLayers();
            mapData.drawControl.marker.enable();
            suggest_key_handler.hideEdits();
            $('.marker-input').addClass('animated bounceIn shake').removeClass('hidden');
            suggest_key_handler.hideContent();
            return false;
        });

        $('.edit-cancel').click(function(event) {
            suggest_key_handler.showContent();
        });

        $('.edit-backspace').click(function(event) {
            suggest_key_handler.deleteLastVertex();
        });

        $('.edit-finish').click(function(event) {
            mapData.drawControl.polyline.completeShape();
        });

        map.on("draw:created", function(e) {
            suggest_key_handler.onDrawCreated(e);
        });

        map.on("draw:drawstart", function(e) {
            suggest_key_handler.onDrawStart(e);
        });

        map.on("draw:drawstop", function(e) {
            suggest_key_handler.onDrawStop(e);
        });

    }
}